import { IdentiteService } from '../../../identite/shared/services/identite.service';
import { Component, OnInit, Input } from '@angular/core';
import { imgCardDrop } from '../../classes/animations';
import { FormControl } from '@angular/forms';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';
import { ModeContact } from '../../../identite/shared/classes/mode-contact';

@Component({
    selector: 'app-admin-list-mode-contact',
    templateUrl: './admin-list-mode-contact.component.html',
    styleUrls: ['./admin-list-mode-contact.component.css'],
    animations: [imgCardDrop]
})
export class AdminListModeContactComponent implements OnInit {

    modesContact: ModeContact[];
    newModeContact = new ModeContact();
    selected = new FormControl(0);

    aclConfig: AclAccess;

    @Input()
    triggerReload: () => void;

    constructor(
        private identiteService: IdentiteService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.modesContact = [];
    }


    getModeContact() {
        this.modesContact = [];
        this.identiteService.getModeContact()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.modesContact.push(new ModeContact(element));
                });
            }
        });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getModeContact();
        }
    }

    insertModeContact(modeContact: ModeContact) {
        this.identiteService.insertModeContact(modeContact)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.newModeContact = new ModeContact();
                this.alertService.success(TRANSLATE('Mode de contact ajouté avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateModeContact(modeContact: ModeContact) {
        this.identiteService.updateModeContact(modeContact.mct_id, modeContact)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Mode de contact modifié avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteModeContact(modeContact: ModeContact) {
        this.identiteService.deleteModeContact(modeContact.mct_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Mode de contact supprimé avec succès'));
                this.getModeContact();
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }
}
